export enum DriverRequestTypeDesktopEnum {
  VertexCollar = 'VertexCollar',
  BluetoothStick = 'BluetoothStick',
  RemoteStick = 'RemoteStick',
  ReleaseTransmitterDevice = 'ReleaseTransmitterDevice',
  HandheldTerminalDevice = 'HandheldTerminalDevice',
  Ftdi = 'Ftdi',
}
